export default "__VITE_ASSET__BS5M7azg__"